import { useTheme } from "@/hooks/use-theme";
import { cn } from "@/lib/utils";

export function SupportCTA() {
  const { resolvedTheme } = useTheme();

  return (
    <div
      className={cn(
        "rounded-glass p-6 relative overflow-hidden text-white",
        resolvedTheme === "dark"
          ? "bg-gradient-to-br from-[rgba(60,179,74,0.1)] to-[rgba(17,29,51,0.9)] border border-[rgba(60,179,74,0.15)]"
          : "bg-gradient-to-br from-[#152642] to-[#1d3456]",
      )}
    >
      {/* Decorative glow */}
      <div className="absolute -top-8 -right-8 w-[100px] h-[100px] rounded-full bg-[#3cb34a] opacity-10 blur-[20px]" />
      <div className="relative">
        <p className="text-[9px] font-bold tracking-[0.15em] text-[#3cb34a] uppercase mb-2">
          Tech Made Human
        </p>
        <h4 className="text-base font-bold mb-2">Need Help?</h4>
        <p className="text-xs opacity-65 leading-relaxed mb-4">
          Brisbane-based team, available 24/7 globally.
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            className="flex-1 py-2.5 rounded-[10px] bg-[#3cb34a] text-white text-[11px] font-bold font-display shadow-[0_4px_16px_rgba(60,179,74,0.25)] hover:bg-[#2a8f35] transition-colors"
          >
            1300 032 010
          </button>
          <button
            type="button"
            className="flex-1 py-2.5 rounded-[10px] border border-white/15 bg-white/5 text-white text-[11px] font-semibold font-display hover:bg-white/10 transition-colors"
          >
            Live Chat
          </button>
        </div>
      </div>
    </div>
  );
}
